import {
  Departments,
  expenseTypes,
  jobBuildingWorkType,
  JobStatus,
  leaveTypes,
  milestoneCompleteStatus,
  minimumTotalAmount,
} from "../lib/constants";
import { formatAmount } from "../lib/utils";

const workPriority = ["Urgent", "High", "Medium", "Low"];
const workImplementationDepartments = ["Design", "Drawing", "Site Visit"];
const departments = [...workImplementationDepartments, "Accounts", "HR"];

const jobBuildingTypes = jobBuildingWorkType;
const minTotalAmount = minimumTotalAmount;

const dummyString = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!";
const getRandomDate = () => {
  return new Date(
    Math.floor(Math.random() * (new Date().getTime() - new Date("2025-01-01").getTime())) + new Date().getTime()
  )
    .toISOString()
    .split("T")[0];
};

const allEmployees = Array.from({ length: 20 }).map((_, idx) => {
  return {
    id: idx + 1,
    name: `Employee ${idx + 1}`,
    department: Object.values(departments)[Math.floor(Math.random() * Object.values(departments).length)],
  };
});

const allJobs = Array.from({ length: 10 }).map((_, idx) => {
  const jobCode = `${Math.floor(Math.random() * 999)}`.padStart(4, "0");
  const documentReferenceNumber = `DOCREF${jobCode}`;

  const jobType = ["New Job", "Existing Job"][Math.floor(Math.random() * 2)];
  const jobWorkType = ["Building Work", "Allied Work"][Math.floor(Math.random() * 2)];
  const isAlliedWork = jobWorkType === "Allied Work";
  const isBuildingWork = jobWorkType === "Building Work";
  const isNewWork = jobType === "New Job";
  const isExistingWork = jobType === "Existing Job";

  const quoteAsPer = ["Sq. Ft.", "Percent", "Lumpsum"][Math.floor(Math.random() * 3)];
  const quoteRatePerSqFt = quoteAsPer === "Sq. Ft." ? Math.floor(Math.random() * 25) + 15 : null;
  const jobArea = quoteAsPer === "Sq. Ft." ? Math.floor(Math.random() * 500) + 1000 : null;
  const sqFtCost = quoteAsPer === "Sq. Ft." ? quoteRatePerSqFt * jobArea : null;
  const quotePercent = quoteAsPer === "Percent" ? Math.floor(Math.random() * 3) + 3 : null;
  const constructionCost = quoteAsPer === "Percent" ? Math.floor(Math.random() * 10000) + 10000 : null;
  const percentCost = quoteAsPer === "Percent" ? constructionCost * (quotePercent / 100) : null;
  const lumpsumCost = quoteAsPer === "Lumpsum" ? Math.floor(Math.random() * 100000) + 10000 : null;

  const amountSelected =
    quoteAsPer === "Lumpsum"
      ? lumpsumCost
      : quoteAsPer === "Percent"
      ? percentCost > minTotalAmount
        ? percentCost
        : minTotalAmount
      : sqFtCost > minTotalAmount
      ? sqFtCost
      : minTotalAmount;

  const discount = (amountSelected * (Math.floor(Math.random() * 10) + 1)) / 100;
  const totalAfterDiscount = amountSelected - discount;
  const gst = totalAfterDiscount * 0.18;
  const grossTotal = totalAfterDiscount + gst;

  const columnDrawings = isAlliedWork || isNewWork ? 2 : 0;
  const slabsCount = isAlliedWork ? 2 : isExistingWork ? 6 : 15;
  const existingSlabsStart = 14;

  const drawingList =
    isAlliedWork || isNewWork
      ? Array.from({ length: columnDrawings + slabsCount })
          .map((_, i) => {
            if (i < columnDrawings) return [`C${i + 1}.1`, `C${i + 1}.2`];
            else return [`S${i - columnDrawings + 1}.1`, `S${i - columnDrawings + 1}.2`];
          })
          .flat()
      : Array.from({ length: slabsCount })
          .map((_, i) => [`S${i + existingSlabsStart}.1`, `S${i + existingSlabsStart}.2`])
          .flat();

  const assignedTaskCount = Math.floor(Math.random() * drawingList.length * 2);
  const assignedTaskArr = Array.from({ length: assignedTaskCount }).map(
    (_, i) =>
      `${drawingList[Math.floor(Math.random() * drawingList.length)]} ${
        ["Design", "Drawing"][Math.floor(Math.random() * 2)]
      }`
  );

  const assignedTaskNames = [...new Set(assignedTaskArr)];

  const assignedTaskList = assignedTaskNames.map((name, i) => {
    const taskDepartment = name.split(" ")[1];
    const employees = allEmployees.filter((emp) => emp.department === taskDepartment);
    const employeeIdList = employees.map((emp) => emp.id);
    const employeeId = employeeIdList[Math.floor(Math.random() * employeeIdList.length)];
    const employeeName = employees.find((emp) => emp.id === employeeId)?.name || "Employee Name";

    const isStatusAssigned = [true, false, true, false, true][Math.floor(Math.random() * 5)];

    const hours = [1, 2][Math.floor(Math.random() * 2)];
    const minutes = [0, 15, 30, 45][Math.floor(Math.random() * 4)];
    const totalTimeMinutes = hours * 60 + minutes;

    const isOverTimeAlloted = isStatusAssigned ? false : [true, false][Math.floor(Math.random() * 2)];

    const usedMinutes = isStatusAssigned
      ? 0
      : isOverTimeAlloted
      ? totalTimeMinutes + Math.floor(Math.random() * 60) + 15
      : Math.floor(Math.random() * totalTimeMinutes);

    const hoursUsed = Math.floor(usedMinutes / 60);
    const minutesUsed = usedMinutes % 60;

    const status =
      hoursUsed === 0 && minutesUsed === 0
        ? "Assigned"
        : isOverTimeAlloted
        ? ["Approved", "Revision_Requested", "Submitted"][Math.floor(Math.random() * 3)]
        : ["Play", "Pause", "Submitted", "Revision_Requested", "Approved"][Math.floor(Math.random() * 5)];

    const submissionCount = status === "Assigned" ? 0 : Math.floor(Math.random() * 3) + 1;
    const submissions = Array.from({ length: submissionCount }).map((_, i) => ({
      revision_number: i + 1,
      note: dummyString,
      file_name: `Job-${jobCode}-${name.split(" ").join("-")}-${i + 1}`,
      file_url: `https://example.com/job-${jobCode}-${name.toLowerCase().split(" ").join("-")}-${i + 1}.pdf`,
      submitted_date: new Date(),
      analystName: "Analyst Name 0001",
      revision_request_reason: status === "Revision_Requested" ? dummyString : null,
      revision_requested_by: ["Analyst", "Client", "Architect", "Builder", "Owner"][Math.floor(Math.random() * 5)],
      status_updated_date: new Date(),
    }));

    return {
      id: i + 1,
      task_name: name,
      employee_id: employeeId,
      employee_name: employeeName,
      alloted_time: `${hours}:${minutes}`,
      priority: workPriority[Math.floor(Math.random() * workPriority.length)],
      note: dummyString,
      time_used: `${hoursUsed}:${minutesUsed}`,
      status,
      documents_shared: [],
      submissions,
    };
  });

  const submissionFiles = assignedTaskList
    .map((task) => task.submissions)
    .flat()
    .map((submission) => ({ name: submission.file_name, url: submission.file_url, category: "outward_documents" }));

  const assignedSiteVisits = Array.from({ length: 2 }).map((_, i) => {
    const employees = allEmployees.filter((emp) => emp.department === "Site Visit");
    const employeeIdList = employees.map((emp) => emp.id);
    const employeeId = employeeIdList[Math.floor(Math.random() * employeeIdList.length)];
    const employeeName = employees.find((emp) => emp.id === employeeId)?.name;

    const status = i === 0 ? "Completed" : "Scheduled";

    const assignedDate = getRandomDate();
    const visitedDate = i === 0 ? assignedDate : null;

    return {
      visit_count: i + 1,
      is_free_visit: true,
      site_engineer_name: employeeName,
      documents_shared: [submissionFiles[0]],
      note: dummyString,
      status: status,
      assigned_date: assignedDate,
      assigned_time: ["First Half", "Second Half"][Math.floor(Math.random() * 2)],
      visited_date: visitedDate,
      visited_time: "10:30",
      images: [
        {
          url: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
          comment: dummyString,
        },
        {
          url: "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
          comment: dummyString,
        },
      ],
      drawing_number: 1,
      revision_number: 1,
      report_summary:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis dolores voluptatum repellat voluptatibus molestiae, aspernatur, possimus cupiditate unde minima architecto accusamus nobis quam libero. Unde, delectus nisi, amet dicta sint blanditiis eius officiis corporis maiores numquam culpa harum magni assumenda, suscipit ratione incidunt at pariatur animi cumque! Animi laborum quam quod perferendis, est sint non sed fuga laboriosam eveniet quos voluptatem molestiae doloremque nemo ullam neque deleniti modi tenetur, asperiores, cum provident! Iste tenetur architecto maxime est ipsam omnis provident distinctio sequi vitae, explicabo assumenda ipsum mollitia delectus, minus voluptas cum dolore, hic accusamus porro necessitatibus. Explicabo quis culpa nisi.",
      report_summary_url: null,
      visit_report_url: "https://example.com/visit_report.pdf",
      director_visit: false,
      analyst_visit: false,
      site_engineer_note: dummyString,
      analyst_note: null,
      analyst_name: null,
      analyst_comment: i === 0 ? dummyString : null,
    };
  });

  // Completed, Cancelled, On Hold not included for now
  const jobStatus =
    assignedTaskCount === 0
      ? "Not Started"
      : assignedTaskList.some((task) => task.submissions.length > 0)
      ? "In Progress"
      : "Assigned";

  const milestonesCount = Math.floor(Math.random() * 3) + 4;
  const milestonesCompleted = ["Not Started", "Assigned"].includes(jobStatus)
    ? 1
    : ["Completed"].includes(jobStatus)
    ? milestonesCount
    : Math.floor(Math.random() * milestonesCount - 1) + 1;

  let milestonePercents = [];
  for (let i = 0; i < milestonesCount - 1; i++) {
    if (i === 0) milestonePercents.push(10);
    else milestonePercents.push(Math.floor(Math.random() * 5) + 15);
  }
  milestonePercents.push(100 - milestonePercents.reduce((a, b) => a + b, 0));

  return {
    id: idx + 1,
    job_code: jobCode,
    document_reference_number: documentReferenceNumber,
    job_status: jobStatus,
    // Basic Details
    job_name: `Project Name ${idx + 1}`,
    job_date: getRandomDate(),
    site_address: `Site Address ${idx + 1}`,
    locality: `Locality ${idx + 1}`,
    // Type of Work
    type_of_work: {
      job_type: jobType,
      job_work_type: jobWorkType,
      allied_work_details: isAlliedWork ? dummyString : null,
      building_type: isBuildingWork ? jobBuildingTypes[Math.floor(Math.random() * jobBuildingTypes.length)] : null,
      basement_count: isBuildingWork ? 2 : null,
      ground_level: isBuildingWork ? "Mezzanine" : null,
      parking_count: isBuildingWork ? 1 : null,
      upper_floor_count: isBuildingWork ? 8 : null,
      additional_floor_count: isNewWork && isBuildingWork ? 4 : null,
      existing_floor_count: isExistingWork && isBuildingWork ? 4 : null,
      basement_drawings_count: isBuildingWork ? 2 : null,
      parking_drawings_count: isBuildingWork ? 1 : null,
      ground_floor_drawings_count: isBuildingWork ? 2 : null,
      upper_floor_drawings_count: isBuildingWork ? 8 : null,
      column_drawings_count: columnDrawings,
      structural_drawings_count: columnDrawings + slabsCount,
    },
    // POC
    client: {
      name: `Client ${jobCode}`,
      mobile: "9999999991",
      phone: "8888888881",
      whatsapp: "7777777771",
      email: `client${jobCode}@email.com`,
      office_address: `Client ${jobCode} Office Address`,
      company_name: `Client ${jobCode} Company Name`,
      gst_number: `client_${jobCode}_gst_number`,
      work_order: ["Required", "Not Required"][Math.floor(Math.random() * 2)],
    },
    architect: {
      name: `Architect ${jobCode}`,
      mobile: "9999999992",
      phone: "8888888882",
      whatsapp: "7777777772",
      email: `architect${jobCode}@email.com`,
      office_address: `Architect ${jobCode} Office Address`,
    },
    builder: {
      name: `Builder ${jobCode}`,
      mobile: "9999999993",
      phone: "8888888883",
      whatsapp: "7777777773",
      email: `builder${jobCode}@email.com`,
      office_address: `Builder ${jobCode} Office Address`,
    },
    owner: {
      name: `Owner ${jobCode}`,
      mobile: "9999999994",
      phone: "8888888884",
      whatsapp: "7777777774",
      email: `owner${jobCode}@email.com`,
      building_name: "A",
      supervisor_name: `Supervisor ${jobCode}`,
      supervisor_contact: "6666666664",
      sanction_number: `sanction_${jobCode}`,
      sanction_date: getRandomDate(),
    },
    sanctioning_authority: "PCMC",
    // Accounting
    quote_as_per: quoteAsPer,
    quote_rate_per_sq_ft: quoteRatePerSqFt,
    job_area: jobArea,
    quote_percent: quotePercent,
    construction_cost: constructionCost,
    total_cost: grossTotal,
    discount: discount,
    site_engineer_visit_fee: 1500,
    site_engineer_free_visit_count: 2,
    director_visit_fee: 1500,
    director_free_visit_count: 2,
    milestone_count: milestonesCount,
    milestones_completed: milestonesCompleted,
    milestones: Array.from({ length: milestonesCount }).map((_, idx) => ({
      payment_percent: milestonePercents[idx],
      milestone_number: idx + 1,
      milestone: `Milestone ${idx + 1}`,
      milestone_status:
        idx + 1 > milestonesCompleted
          ? "Not Started"
          : idx + 1 < milestonesCompleted
          ? "Payment Requested"
          : "Milestone Achieved",
    })),
    // Quotation
    letterhead: ["No letterhead", "Structualtants Design LLP", "Shirke Consultants Pvt. Ltd."][
      Math.floor(Math.random() * 3)
    ],
    signature: ["R. V. Shirke", "S. S. Desarda"][Math.floor(Math.random() * 2)],
    files: [
      {
        name: `Quotation: ${documentReferenceNumber}`,
        url: "https://example.com/quotation.pdf",
        category: "financial_documents",
      },
      ...submissionFiles,
    ],
    is_quotation_frozen: [false, true][Math.floor(Math.random() * 2)],
    assigned_tasks: assignedTaskList,
    assigned_site_visits: assignedSiteVisits,
  };
});

const commonJobDetails = (job) => ({
  id: job.id,
  job_code: job.job_code,
  job_name: job.job_name,
  job_date: job.job_date,
  job_status: job.job_status,
  job_value: job.total_cost,
  client_name: job.client.name,
  milestone_count: job.milestone_count,
  milestones_completed: job.milestones_completed,
});
const poc = (job) => ({ client: job.client, architect: job.architect, builder: job.builder, owner: job.owner });

export const allJobsAnalyst = allJobs.map((job) => commonJobDetails(job));

export const analystJobDetailsById = (id) => {
  const job = allJobs.find((job) => job.id === +id);
  if (!job) return null;

  return {
    ...commonJobDetails(job),
    is_quotation_frozen: job.is_quotation_frozen,
    site_address: job.site_address,
    locality: job.locality,
    site_engineer_free_visit_count: job.site_engineer_free_visit_count,
    director_free_visit_count: job.director_free_visit_count,
    type_of_work: job.type_of_work,
    ...poc(job),
    sanctioning_authority: job.sanctioning_authority,
    milestones: job.milestones,
    assigned_tasks: job.assigned_tasks,
    assigned_site_visits: job.assigned_site_visits,
    files: job.files,
  };
};

export const staticJobsList = Array.from({ length: 10 }).map((_, idx) => {
  const jobCode = `${Math.floor(Math.random() * 999)}`.padStart(4, "0");
  const milestoneCount = Math.floor(Math.random() * 5) + 3;
  const drawingCount = Math.floor(Math.random() * 5) + 3;
  let taskOptions = ["C1.1", "C1.2", "C2.1", "C2.2"];
  for (let i = 0; i < drawingCount; i++) {
    taskOptions.push(`S${i + 1}.1`);
    taskOptions.push(`S${i + 2}.2`);
  }
  const assignedDrawingTasksCount = Math.floor(Math.random() * taskOptions.length * 2) || 1;

  const taskAssignmentDepartments = ["Design", "Drawing"];
  let assignedDrawingOptions = [];
  let assignedDesignOptions = [];
  let assignedTasks = [];
  for (let i = 0; i < assignedDrawingTasksCount; i++) {
    const taskIndex = Math.floor(Math.random() * taskOptions.length);
    const taskDepartment = taskAssignmentDepartments[Math.floor(Math.random() * taskAssignmentDepartments.length)];
    if (taskDepartment === "Design") {
      if (!assignedDesignOptions.includes(taskOptions[taskIndex])) {
        assignedDesignOptions.push(taskOptions[taskIndex]);
        assignedTasks.push(`${taskOptions[taskIndex]} Design`);
        continue;
      }
      if (!assignedDrawingOptions.includes(taskOptions[taskIndex])) {
        assignedDrawingOptions.push(taskOptions[taskIndex]);
        assignedTasks.push(`${taskOptions[taskIndex]} Drawing`);
        continue;
      }
    } else {
      if (!assignedDrawingOptions.includes(taskOptions[taskIndex])) {
        assignedDrawingOptions.push(taskOptions[taskIndex]);
        assignedTasks.push(`${taskOptions[taskIndex]} Drawing`);
        continue;
      }
      if (!assignedDesignOptions.includes(taskOptions[taskIndex])) {
        assignedDesignOptions.push(taskOptions[taskIndex]);
        assignedTasks.push(`${taskOptions[taskIndex]} Design`);
        continue;
      }
    }
  }

  const jobDate = new Date(2025, Math.floor(Math.random() * 12), Math.floor(Math.random() * 31));

  return {
    id: idx + 1,
    job_code: jobCode,
    job_name: `Project ${jobCode}`,
    job_status: Object.values(JobStatus)[Math.floor(Math.random() * Object.values(JobStatus).length)],
    job_owner: `Job Owner ${jobCode}`,
    job_value: Math.floor(Math.random() * 100000) + 1,
    job_date: jobDate.toISOString().split("T")[0],
    client_name: `Client ${jobCode}`,
    milestone_count: milestoneCount,
    milestones_completed: Math.floor(Math.random() * (milestoneCount - 1)),
    tasks: Array.from({ length: assignedTasks.length }).map((item, taskIdx) => ({
      id: taskIdx + 1,
      name: (assignedTasks as any[])[0]?.name || "Task",  // assignedTasks is array
      priority: workPriority[Math.floor(Math.random() * workPriority.length)],
      documents_shared: [],
      time_used: "00:00",
      note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
    })),
  };
});

export const staticJobsListAccounts = staticJobsList.map((item) => {
  const milestoneCount = Math.floor(Math.random() * 5) + 3;
  const milestonesCompleted = Math.floor(Math.random() * (milestoneCount - 1)) + 1;
  const milestoneStatus =
    milestonesCompleted >= 1
      ? milestoneCompleteStatus[Math.floor(Math.random() * milestoneCompleteStatus.length)]
      : "Not Started";
  return {
    id: item.id,
    job_code: item.job_code,
    job_date: new Date().toISOString().split("T")[0],
    job_name: item.job_name,
    job_value: item.job_value,
    milestone_count: milestoneCount,
    milestones_completed: milestonesCompleted,
    milestone_status: milestoneStatus,
    milestone_achieve_date: new Date().toISOString().split("T")[0],
  };
});

export const getJobsListEmployee = (weekNo) =>
  Array.from({ length: 10 })
    .map((item, idx) => {
      const jobCode = `${Math.floor(Math.random() * 999)}`.padStart(4, "0");
      let taskOptions = Array.from({ length: 20 }).map((_, i) =>
        i < 4 ? (i % 2 === 0 ? `C${i + 1}.1` : `C${i + 1}.2`) : i % 2 === 0 ? `S${i + 1}.1` : `S${i + 2}.2`
      );

      let taskNames: Set<string> | string[] = new Set<string>();
      while (taskNames.size < Math.floor(Math.random() * 4) + 1) {
        taskNames.add(
          `${taskOptions[Math.floor(Math.random() * taskOptions.length)]} ${
            ["Design", "Drawing"][Math.floor(Math.random() * 2)]
          }`
        );
      }
      taskNames = Array.from(taskNames as Set<string>) as string[];

      return {
        id: idx + 1,
        job_id: idx + 1,
        job_code: jobCode,
        job_name: `Project ${jobCode}`,
        job_status: JobStatus.NOT_STARTED,
        department: [Departments.DESIGN, Departments.DRAWING][Math.floor(Math.random() * 2)],
        tasks: taskNames
          .map((taskName, taskIdx) => ({
            id: taskIdx + 1,
            name: taskName,
            alloted_time: Math.floor(Math.random() * 3) + 1 + ":" + ["00", "30"][Math.floor(Math.random() * 2)],
            priority: workPriority[Math.floor(Math.random() * workPriority.length)],
            time_used: "00:10",
            current_working_status: "Pause",
            last_play: null,
            last_pause: null,
            note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
          }))
          .sort((a, b) => {
            return workPriority.indexOf(a.priority) - workPriority.indexOf(b.priority);
          }),
      };
    })
    .sort((a, b) => {
      return (
        b.tasks.filter((task) => task.priority === "Urgent").length -
          a.tasks.filter((task) => task.priority === "Urgent").length ||
        b.tasks.filter((task) => task.priority === "High").length -
          a.tasks.filter((task) => task.priority === "High").length ||
        b.tasks.filter((task) => task.priority === "Medium").length -
          a.tasks.filter((task) => task.priority === "Medium").length ||
        b.tasks.filter((task) => task.priority === "Low").length -
          a.tasks.filter((task) => task.priority === "Low").length
      );
    });

const generateStaticPOCData = (key, code) => ({
  name: `${key} ${code}`,
  mobile: "1234567890",
  phone: "1234567890",
  whatsapp: "1234567890",
  email: `${key}${code}@email.com`,
  office_address: "Chinchwad, Pune",
});

const generateStaticJobData = () => {
  const jobCode = `${Math.floor(Math.random() * 999)}`.padStart(4, "0");
  const jobType = ["Existing Job", "New Job"][Math.floor(Math.random() * 2)];
  const jobWorkType = ["Building Work", "Allied Work"][Math.floor(Math.random() * 2)];
  const milestoneCount = 10;
  const milestonesCompleted = 8;
  const milestoneStatus = milestoneCompleteStatus[Math.floor(Math.random() * milestoneCompleteStatus.length)];

  const totalBeforeGST = 120000;
  const gst = totalBeforeGST * 0.18;
  const totalAfterGST = totalBeforeGST + gst;

  return {
    id: 1,
    job_code: jobCode,
    document_reference_number: `DOCREF${jobCode}`,
    job_name: `Project ${jobCode}`,
    job_date: new Date(
      Math.floor(Math.random() * (new Date().getTime() - new Date("2025-01-01").getTime())) +
        new Date("2025-01-01").getTime()
    )
      .toISOString()
      .split("T")[0],
    site_address: "Chinchwad, Pune",
    locality: "Pune",
    job_status: JobStatus.NOT_STARTED,
    job_type: jobType,
    job_work_type: jobWorkType,
    allied_work_details:
      jobWorkType === "Allied Work" ? "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!" : null,
    building_type: "Residential Building",
    basement_count: 2,
    parking_count: 2,
    ground_floor: "Mezzanine",
    upper_floor_count: 12,
    additional_floor_count: 4,
    existing_floor_count: 4,
    basement_drawings_count: 2,
    parking_drawings_count: 2,
    ground_floor_drawings_count: 2,
    upper_floor_drawings_count: 12,
    existing_floor_drawing_count: 4,
    column_drawings_count: 2,
    structural_drawings_count: jobWorkType === "Allied Work" ? 2 : 20,
    client: {
      ...generateStaticPOCData("Client", "0001"),
      company_name: "Company 0001",
      gst_number: "A123456789",
      work_order: "Not Required",
    },
    architect: generateStaticPOCData("Architect", "0001"),
    builder: generateStaticPOCData("Builder", "0001"),
    owner: {
      ...generateStaticPOCData("Owner", "0001"),
      building_name: "Building 0001",
      supervisor_name: "Supervisor 0001",
      supervisor_contact: "1234567890",
      sanction_number: "Sanction 0001",
      sanction_date: "2025-04-30",
    },
    sanctioning_authority: "PMC",
    quote_as_per: "Percent",
    quote_rate_per_sq_ft: null,
    job_area: null,
    quote_percent: 30,
    construction_cost: 50000,
    total_cost: 65000,
    site_engineer_visit_fee: 1500,
    site_engineer_free_visit_count: 2,
    director_visit_fee: 1500,
    director_free_visit_count: 2,
    milestone_count: milestoneCount,
    milestones_completed: milestonesCompleted,
    milestone_status: milestoneStatus,
    milestone_achieve_date: new Date().toISOString().split("T")[0],
    milestones: Array.from({ length: 10 }).map((_, idx) => {
      return {
        milestone_number: idx + 1,
        payment_percent: 10,
        milestone: `Milestone ${idx + 1}`,
        status: milestoneStatus,
        gross_amount: totalAfterGST * 0.1,
        gst_amount: totalAfterGST * 0.1 * 0.18,
        paymentMadeFor: "amount", // amount, full
      };
    }),
    // milestones: [
    //   {
    //     milestone_number: 1,
    //     payment_percent: 10,
    //     milestone: "Advance",
    //     status: "Invoice Sent",
    //     proforma: { name: "Proforma 1 (JobCode_proformaName)", url: "" },
    //     invoice: { name: "Invoice 1 (JobCode_invoiceName)", url: "" },
    //   },
    //   {
    //     milestone_number: 2,
    //     payment_percent: 40,
    //     milestone: "At the time of delivery of set of Preliminary Drawings for Estimation",
    //     proforma: { name: "Proforma 2 (JobCode_proformaName)", url: "" },
    //   },
    //   {
    //     milestone_number: 3,
    //     payment_percent: 40,
    //     milestone: "At the time of delivery of set of Preliminary Design for Estimation",
    //   },
    //   { milestone_number: 4, payment_percent: 10, milestone: "At the time of delivering completion of work." },
    // ],
    discount: 5000,
    total_after_discount: 60000,
    letterhead: "No Letterhead",
    signature: "R. V. Shirke",
    files: [
      {
        name: "Appointment letter",
        file_id: 1,
        url: "https://example.com/appointment_letter.pdf",
        document_category: "outward_documents",
      },
      {
        name: "Document 2",
        file_id: 2,
        url: "https://example.com/document2.pdf",
        document_category: "inward_documents",
      },
      {
        name: "Acceptance-A letter",
        file_id: 3,
        url: "https://example.com/acceptance_letter.pdf",
        document_category: "outward_documents",
      },
      {
        name: "Approved Quotation",
        file_id: 4,
        url: "https://example.com/job_quotation.pdf",
        document_category: "financial_documents",
      },
      {
        name: `${jobCode}_proforma1`,
        file_id: 5,
        url: `https://example.com/${jobCode}_proforma1.pdf`,
        document_category: "financial_documents",
      },
      {
        name: `${jobCode}_invoice1`,
        file_id: 6,
        url: `https://example.com/${jobCode}_invoice1.pdf`,
        document_category: "financial_documents",
      },
      {
        name: `${jobCode}_proforma2`,
        file_id: 7,
        url: `https://example.com/${jobCode}_proforma2.pdf`,
        document_category: "financial_documents",
      },
    ],

    commercials: [
      {
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        name: "Visit 1",
        url: "/assets/images/undraw_under-construction_c2y1 1.svg",
      },
      {
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        name: "Visit 2",
        url: "/assets/images/undraw_under-construction_c2y1 1.svg",
      },
      {
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        name: "Visit 3",
        url: "/assets/images/undraw_under-construction_c2y1 1.svg",
      },
      {
        comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        name: "Visit 4",
        url: "/assets/images/undraw_under-construction_c2y1 1.svg",
      },
    ],
    work_details: [
      {
        id: 1,
        work_assigned: {
          department: "Drawing",
          hours: "3",
          minutes: "30",
          priority: "High",
          employee_name: "John Doe",
          employee_id: 1,
          documents: [{ name: "Document 1", url: "" }],
          note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        },
        tasks: [
          {
            id: 1,
            name: "Task 1",
            versions: [
              {
                revision: 1,
                document: { name: "Document 1", upload_date: "01/01/2023", url: "" },
                note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
              },
            ],
          },
        ],
        poc: { client: "Alice Johnson", architect: "Bob Smith", builder: "Charlie Brown", owner: "Diana Prince" },
      },
    ],
    employee_work_details: {
      time_slot: "10:00 - 1:30",
      job_duration: "03:30",
      department: "Drawing",
      employee_name: "Bob Smith",
      priority: "High",
      documents: [{ name: "Document 1", url: "" }],
      note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
      tasks: [
        {
          task_id: 1,
          name: "Task 1",
          versions: [
            {
              version: 1,
              document: { name: "Document 1", url: "", date: "01/01/2023" },
              note: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quibusdam voluptatibus fugit nostrum officiis autem, maiores commodi atque qui quam ullam, eius alias provident dolore illum aliquid dolorem voluptates quisquam sint.",
            },
          ],
        },
      ],
    },
    employee_assigned_work: [
      {
        task_id: 1,
        name: "S1.1 Design",
        work_timeline: "02:30",
        alloted_time: "02:30",
        priority: "High",
        employee_name: "Bob Smith",
        inward_documents: [
          { name: "Document 1", url: "" },
          { name: "Document 2", url: "" },
          { name: "Document 3", url: "" },
        ],
        note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        submissions: [],
        last_play: "2025-04-11T02:45:24.998Z",
        current_working_status: "play",
        time_used: "00:10",
      },
      {
        task_id: 2,
        name: "S1.2 Design",
        alloted_time: "02:30",
        priority: "High",
        employee_name: "Bob Smith",
        inward_documents: [
          { name: "Document 1", url: "" },
          { name: "Document 2", url: "" },
          { name: "Document 3", url: "" },
        ],
        note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        current_working_status: "completed",
        time_used: "01:30",
        last_pause: new Date(),
        submissions: [
          {
            date: "01/01/2023",
            url: "",
            note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            revision_requested: true,
            revised: true,
            analyst_name: "John Doe",
            analyst_comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            poc: "Client",
            poc_name: "Alice Johnson",
            request_date: "02/01/2023",
            poc_comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
          },
          {
            date: "04/01/2023",
            url: "",
            note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            revision_requested: false,
          },
        ],
      },
      {
        id: 3,
        name: "S1.3 Design",
        alloted_time: "02:30",
        priority: "High",
        employee_name: "Bob Smith",
        inward_documents: [
          { name: "Document 1", url: "" },
          { name: "Document 2", url: "" },
          { name: "Document 3", url: "" },
        ],
        note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        current_working_status: "paused",
        time_used: "01:00",
        submissions: [
          {
            date: "01/01/2023",
            url: "",
            note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            revision_requested: true,
            revised: false,
            analyst_name: "John Doe",
            analyst_comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            poc: "Client",
            poc_name: "Alice Johnson",
            request_date: "02/01/2023",
            poc_comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
          },
        ],
      },
    ],
    assigned_work: [
      {
        task_name: "S1.1 Design",
        isActive: true,
        employee_name: "Bob Smith",
        employee_id: 1,
        work_timeline: "02 hrs: 30 min",
        assigned_date: "01/01/2023",
        assigned_time: "10:00 - 1:30",
        priority: "High",
        note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        inward_documents: [
          { name: "Document 1", url: "" },
          { name: "Document 2", url: "" },
          { name: "Document 3", url: "" },
        ],
        submissions: [
          {
            task_id: 1,
            date: "01/01/2025",
            url: "https://example.com/submission_1.pdf",
            note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            revision_requested: true,
            analyst_name: "John Doe",
            analyst_comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            poc: "Client",
            poc_name: "Alice Johnson",
            request_date: "02/01/2023",
            poc_comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            updateDate: "03/04/2025",
            work_shared: true,
            approved: false,
          },
          {
            date: "04/01/2023",
            url: "https://example.com/submission_2.pdf",
            note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            analyst_name: "John Doe",
            analyst_comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            poc: "Client",
            poc_name: "Alice Johnson",
            request_date: "07/01/2023",
            poc_comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            revision_requested: true,
            work_shared: true,
            approved: false,
          },
        ],
      },
      {
        task_name: "C1.1 Design",
        isActive: true,
        employee_name: "John Doe",
        employee_id: 1,
        work_timeline: "02 hrs: 30 min",
        assigned_date: "01/01/2023",
        assigned_time: "10:00 - 1:30",
        priority: "High",
        note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        inward_documents: [
          { name: "Document 1", url: "" },
          { name: "Document 3", url: "" },
          { name: "Document 4", url: "" },
        ],
        submissions: [
          {
            date: "01/01/2023",
            url: "",
            note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            revision_requested: false,
            work_shared: false,
          },
        ],
      },
      {
        task_name: "C2.1 Design",
        isActive: true,
        employee_name: "John Doe",
        employee_id: 1,
        work_timeline: "02 hrs: 30 min",
        assigned_date: "01/01/2023",
        assigned_time: "10:00 - 1:30",
        priority: "Low",
        note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        inward_documents: [
          { name: "Document 1", url: "" },
          { name: "Document 2", url: "" },
          { name: "Document 3", url: "" },
        ],
        submissions: [
          {
            date: "01/01/2023",
            url: "",
            note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            revision_requested: true,
            analyst_name: "John Doe",
            analyst_comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            poc: "Client",
            poc_name: "Alice Johnson",
            request_date: "02/01/2023",
            poc_comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            work_shared: true,
            approved: false,
          },
          {
            date: "04/01/2023",
            url: "",
            note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
            revision_requested: false,
            work_shared: true,
            poc: "Client",
            poc_name: "Alice Johnson",
            request_date: "07/01/2023",
            approved: false,
          },
        ],
      },
    ],
    certificates: {
      inward_documents: [
        { name: "Document 1", url: "" },
        { name: "Document 2", url: "" },
        { name: "Document 3", url: "" },
      ],
      letters: [
        {
          appointment_letter: null,
          acceptance_A_letter: null,
          acceptance_B_letter: null,
          plinth_certificate: null,
          stability_A_certificate: null,
          stability_B_certificate: null,
          completion_certificate: null,
          lift_stability_certificate: null,
          noc: null,
        },
      ],
      approved_quotation: { name: "Job_1_Approved_Quotation", url: "" },
    },
    assigned_site_visits: [
      {
        employee_id: 6,
        employee_name: "Alice Johnson",
        visit_count: 1,
        is_free_visit: true,
        max_free_visit_count: 5,
        documents_shared: {
          inward_documents: [{ name: "Document 1", url: "https://example.com/document1.pdf" }],
          outward_documents: [{ name: "Document 6", url: "https://example.com/document6.pdf" }],
        },
        site_address: "804 F, Random street, random lane, Wakad, Pune, Maharashtra 400060",
        locality: "Wakad, Pune",
        note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
        status: "Completed",
        assigned_date: "2025-04-08",
        visited_date: "2025-04-08",
        visited_time: "10:00",
        images: Array.from({ length: 5 }).map((_, i) => ({
          url: "https://images.unsplash.com/photo-1517089596392-fb9a9033e05b?q=80&w=3474&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          comment:
            "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Iure veniam quibusdam vitae sequi temporibus provident dolor, saepe labore corporis excepturi tenetur id, exercitationem sunt nisi consequatur minus, animi vero porro!",
        })),
        drawing_number: 1,
        revision_number: 3,
        report_summary:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo alias eos nobis harum. Repudiandae, ratione tenetur labore deleniti consectetur architecto inventore quibusdam aliquam consequuntur laudantium culpa, recusandae minima, quo quis odio a quae. Vitae ducimus illo, voluptas amet alias minima eum consequuntur atque hic incidunt, deserunt rerum! Sit necessitatibus ea atque itaque voluptatibus, a dolores sapiente fugit iste nemo autem. Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo alias eos nobis harum. Repudiandae, ratione tenetur labore deleniti consectetur architecto inventore quibusdam aliquam consequuntur laudantium culpa, recusandae minima, quo quis odio a quae.",
        visit_report: "https://example.com/visit_report.pdf",
        site_engineer_note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
      },

      // {
      //   employee_id: 3,
      //   employee_name: "John Doe",
      //   visit_count: 2,
      //   is_free_visit: true,
      //   max_free_visit_count: 5,
      //   documents_shared: {
      //     inward_documents: [
      //       { name: "Document 1", url: "https://example.com/document1.pdf" },
      //       { name: "Document 2", url: "https://example.com/document2.pdf" },
      //       { name: "Document 3", url: "https://example.com/document3.pdf" },
      //     ],
      //     outward_documents: [
      //       { name: "Document 4", url: "https://example.com/document4.pdf" },
      //       { name: "Document 5", url: "https://example.com/document5.pdf" },
      //     ],
      //   },
      //   site_address: "804 F, Random street, random lane, Wakad, Pune, Maharashtra 400060",
      //   note: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
      //   status: "Pending",
      //   assigned_date: new Date().toISOString().split("T")[0],
      //   visited_date: null,
      //   visited_time: null,
      //   images: [],
      // },
    ],
  };
};

export const staticJobData = generateStaticJobData();

export const jobViewByIdEmployee = {
  id: staticJobData.id,
  job_id: staticJobData.id,
  job_code: staticJobData.job_code,
  job_status: staticJobData.job_status,
  job_name: staticJobData.job_name,
  job_date: staticJobData.job_date,
  site_address: staticJobData.site_address,
  locality: staticJobData.locality,
  type_of_work: {
    allied_work_specification: staticJobData.allied_work_details,
    building_type: staticJobData.building_type,
    basement_count: staticJobData.basement_count,
    parking_count: staticJobData.parking_count,
    ground_floor: staticJobData.ground_floor,
    upper_floor_count: staticJobData.upper_floor_count,
    additional_floor_count: staticJobData.additional_floor_count,
    existing_floor_count: staticJobData.existing_floor_count,
  },
  tasks_assigned: staticJobData.employee_assigned_work,
};

export const jobViewByIdAccounts = {
  id: staticJobData.id,
  job_id: staticJobData.id,
  job_code: staticJobData.job_code,
  job_date: staticJobData.job_date,
  job_name: staticJobData.job_name,
  milestone_count: staticJobData.milestone_count,
  milestones_completed: staticJobData.milestones_completed,
  milestone_status: staticJobData.milestone_status,
  milestone_achieve_date: staticJobData.milestone_achieve_date,
  job_value: staticJobData.total_after_discount,
  owner_name: staticJobData.owner.name,
  milestones: staticJobData.milestones,
  site_address: staticJobData.site_address,
  locality: staticJobData.locality,
  client: staticJobData.client,
  architect: staticJobData.architect,
  builder: staticJobData.builder,
  owner: {
    ...staticJobData.owner,
    sanctioning_authority: staticJobData.sanctioning_authority,
  },
  files: staticJobData.files,
  site_visit_images: [],
};

export const staticLeavesByEmployeeId = Array.from({ length: 20 })
  .map((_, idx) => {
    const startDate = new Date(
      Math.floor(Math.random() * (new Date().getTime() - new Date("2025-01-01").getTime())) +
        new Date("2025-01-01").getTime()
    )
      .toISOString()
      .split("T")[0];
    const hasEndDate = [true, false][Math.floor(Math.random() * 2)];
    const endDate = new Date(
      Math.floor(Math.random() * (new Date().getTime() - new Date(startDate).getTime())) + new Date(startDate).getTime()
    )
      .toISOString()
      .split("T")[0];
    const start_date_session = ["Full Day", "Session 1 (First Half of the day)", "Session 2 (Second Half of the day)"][
      Math.floor(Math.random() * 3)
    ];
    const end_date_session = hasEndDate
      ? ["Full Day", "Session 1 (First Half of the day)", "Session 2 (Second Half of the day)"][
          Math.floor(Math.random() * 3)
        ]
      : null;
    // let number_of_days = start - end + 1;
    let number_of_days = (new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24) + 1;
    if (!hasEndDate) number_of_days = 1;
    else if (end_date_session !== "Full Day") number_of_days -= 0.5;
    else if (start_date_session !== "Full Day") number_of_days -= 0.5;
    const appliedOn = new Date(new Date(startDate).getTime() - 7 * 24 * 50 * 60 * 1000).toISOString().split("T")[0];

    const status = ["pending", "approved", "rejected"][Math.floor(Math.random() * 3)];
    const rejectionReason =
      status === "rejected" ? "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!" : null;

    return {
      id: idx + 1,
      employee_id: (JSON.parse(localStorage.getItem("userData") || "{}"))?.user_id,
      department: departments[Math.floor(Math.random() * departments.length)],
      employee_name: (JSON.parse(localStorage.getItem("userData") || "{}"))?.name,
      leave_type: leaveTypes[Math.floor(Math.random() * leaveTypes.length)],
      leave_status: ["Pending", "Approved", "Rejected"][Math.floor(Math.random() * 3)],
      reason: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
      start_date: startDate,
      start_date_session: start_date_session,
      end_date: hasEndDate ? endDate : null,
      end_date_session: hasEndDate ? end_date_session : null,
      number_of_days: number_of_days,
      is_paid: [true, false][Math.floor(Math.random() * 2)],
      applied_on: appliedOn,
      status: status,
      rejection_reason: rejectionReason,
    };
  })
  .sort((a, b) => new Date(b.applied_on).getTime() - new Date(a.applied_on).getTime())
  .map((leave, idx) => ({
    ...leave,
    id: idx + 1,
  }));

export const staticVouchersByEmployeeId = Array.from({ length: 20 })
  .map((_, idx) => {
    const status = ["active", "accepted", "Rejected"][Math.floor(Math.random() * 3)].toLowerCase();
    const amountRequested = Math.floor(Math.random() * 10000) + 1;
    const amountReimbursed = status === "approved" ? amountRequested : null;
    const reasonForRejection = status === "rejected" ? `Reason for rejection of voucher ${idx + 1}` : null;
    const appliedOn = new Date(
      Math.floor(Math.random() * (new Date().getTime() - new Date("2025-01-01").getTime())) +
        new Date("2025-01-01").getTime()
    )
      .toISOString()
      .split("T")[0];

    return {
      id: idx + 1,
      employee_id: JSON.parse(localStorage.getItem("userData"))?.user_id,
      department: departments[Math.floor(Math.random() * departments.length)],
      employee_name: JSON.parse(localStorage.getItem("userData"))?.name,
      expense_type: expenseTypes[Math.floor(Math.random() * expenseTypes.length)],
      status,
      amount_requested: amountRequested,
      amount_reimbursed: amountReimbursed,
      reason_for_rejection: reasonForRejection,
      applied_on: appliedOn,
    };
  })
  .sort((a, b) => new Date(b.applied_on).getTime() - new Date(a.applied_on).getTime())
  .map((voucher, idx) => ({
    ...voucher,
    id: idx + 1,
  }));

export const staticAllLeavesForAdmin = Array.from({ length: 20 }).map((_, idx) => {
  const startDate = new Date(
    Math.floor(Math.random() * (new Date().getTime() - new Date("2025-01-01").getTime())) +
      new Date("2025-01-01").getTime()
  )
    .toISOString()
    .split("T")[0];
  const hasEndDate = [true, false][Math.floor(Math.random() * 2)];
  const endDate = new Date(
    Math.floor(Math.random() * (new Date().getTime() - new Date(startDate).getTime())) + new Date(startDate).getTime()
  )
    .toISOString()
    .split("T")[0];
  const start_date_session = ["Full Day", "Session 1 (First Half of the day)", "Session 2 (Second Half of the day)"][
    Math.floor(Math.random() * 3)
  ];
  const end_date_session = hasEndDate
    ? ["Full Day", "Session 1 (First Half of the day)", "Session 2 (Second Half of the day)"][
        Math.floor(Math.random() * 3)
      ]
    : null;
  // let number_of_days = start - end + 1;
  let number_of_days = (new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24) + 1;
  if (!hasEndDate) number_of_days = 1;
  else if (end_date_session !== "Full Day") number_of_days -= 0.5;
  else if (start_date_session !== "Full Day") number_of_days -= 0.5;
  const appliedOn = new Date(new Date(startDate).getTime() - 7 * 24 * 50 * 60 * 1000).toISOString().split("T")[0];

  const status = ["pending", "approved", "rejected"][Math.floor(Math.random() * 3)];
  const rejectionReason =
    status === "rejected" ? "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!" : null;

  return {
    id: idx + 1,
    employee_id: idx + 1,
    employee_name: `Employee ${idx + 1}`,
    department: departments[Math.floor(Math.random() * departments.length)],
    leave_type: leaveTypes[Math.floor(Math.random() * leaveTypes.length)],
    start_date: startDate,
    start_date_session: start_date_session,
    end_date: hasEndDate ? endDate : null,
    end_date_session: hasEndDate ? end_date_session : null,
    reason: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
    number_of_days: number_of_days,
    is_paid: [true, false][Math.floor(Math.random() * 2)],
    applied_on: appliedOn,
    status: status,
    rejection_reason: rejectionReason,
  };
});

export const staticAllVouchersForAdmin = Array.from({ length: 20 })
  .map((_, idx) => {
    const status = ["active", "accepted", "rejected"][Math.floor(Math.random() * 3)].toLowerCase();
    const amountRequested = Math.floor(Math.random() * 10000) + 1;
    const amountReimbursed = status === "accepted" ? amountRequested : null;
    const reasonForRejection = status === "rejected" ? `Reason for rejection of voucher ${idx + 1}` : null;
    const appliedOn = new Date(
      Math.floor(Math.random() * (new Date().getTime() - new Date("2025-01-01").getTime())) +
        new Date("2025-01-01").getTime()
    )
      .toISOString()
      .split("T")[0];

    return {
      id: idx + 1,
      employee_id: idx + 1,
      department: departments[Math.floor(Math.random() * departments.length)],
      employee_name: `Employee ${idx + 1}`,
      expense_type: expenseTypes[Math.floor(Math.random() * expenseTypes.length)],
      status,
      amount_requested: amountRequested,
      amount_reimbursed: amountReimbursed,
      reason_for_rejection: reasonForRejection,
      applied_on: appliedOn,
      comment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
    };
  })
  .sort((a, b) => new Date(b.applied_on).getTime() - new Date(a.applied_on).getTime())
  .map((voucher, idx) => ({
    ...voucher,
    id: idx + 1,
  }));

const allInterviewStages = [
  "round-1",
  "round-2",
  "round-3",
  "offer-letter",
  "onboarding-process",
  "document-collection",
  "contract",
  "induction",
];

export const candidatesData = Array.from({ length: 40 }).map((item, idx) => {
  const applicationDate = new Date(
    Math.floor(Math.random() * (new Date().getTime() - new Date("2025-01-01").getTime())) +
      new Date("2025-01-01").getTime()
  );

  const status = ["Candidate", "Approved", "Rejected", "In Process"][Math.floor(Math.random() * 4)];

  const nextInterviewDate =
    status !== "Candidate"
      ? new Date(
          Math.floor(Math.random() * (new Date().getTime() - new Date(applicationDate).getTime())) +
            new Date(applicationDate).getTime()
        )
          .toISOString()
          .split("T")[0]
      : null;

  const interviewTime =
    status !== "Candidate"
      ? `${Math.floor(Math.random() * 12) + 1}:${Math.floor(Math.random() * 60)
          .toString()
          .padStart(2, "0")}${["AM", "PM"][Math.floor(Math.random() * 2)]}`
      : null;

  const rejectionReason =
    status === "Rejected" ? "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!" : null;

  const currentInterviewRound =
    status !== "Candidate" && allInterviewStages[Math.floor(Math.random() * allInterviewStages.length)];
  const currentInterviewRoundIndex = status !== "Candidate" && allInterviewStages.indexOf(currentInterviewRound);

  const salaryCap = Math.floor(Math.random() * 900000) + 20000;
  // more than or equal to salary cap
  const salaryExpectation = Math.floor(Math.random() * 100000) + salaryCap;
  // less than salary cap
  const salaryFinalized = currentInterviewRoundIndex > 2 ? Math.floor(Math.random() * (salaryCap - 20000)) + 20000 : "";

  const age = Math.floor(Math.random() * 25) + 20;
  const gender = ["Male", "Female"][Math.floor(Math.random() * 2)];
  // get date of birth from age
  const dob = new Date(new Date().getTime() - age * 365 * 24 * 60 * 60 * 1000);
  const dobString = dob.toISOString().split("T")[0];

  const offerLetters =
    currentInterviewRoundIndex > 3
      ? {
          name: "Offer Letter",
          send_date: new Date().toISOString().split("T")[0],
          url: "https://example.com/offer-letter.pdf",
          accepted_date: new Date().toISOString().split("T")[0],
        }
      : currentInterviewRoundIndex === 3
      ? [
          {
            name: "Offer Letter",
            send_date: new Date().toISOString().split("T")[0],
            url: "https://example.com/offer-letter.pdf",
          },
          {
            name: "Offer Letter",
            send_date: new Date().toISOString().split("T")[0],
            url: "https://example.com/offer-letter.pdf",
            // accepted_date: new Date().toISOString().split("T")[0],
            rejected_date: new Date().toISOString().split("T")[0],
          },
        ][Math.floor(Math.random() * 2)]
      : null;

  const scores = {
    integrated_reasoning_score: currentInterviewRoundIndex > 0 ? Math.floor(Math.random() * 20) : "",
    quantitative_reasoning_score: currentInterviewRoundIndex > 0 ? Math.floor(Math.random() * 20) : "",
    verbal_reasoning_score: currentInterviewRoundIndex > 0 ? Math.floor(Math.random() * 20) : "",
    round_1_score: currentInterviewRoundIndex > 0 ? Math.floor(Math.random() * 60) : "",
    integrated_reasoning_remark: currentInterviewRoundIndex > 0 ? "Integrated Reasoning Remark" : "",
    quantitative_reasoning_remark: currentInterviewRoundIndex > 0 ? "Quantitative Reasoning Remark" : "",
    verbal_reasoning_remark: currentInterviewRoundIndex > 0 ? "Verbal Reasoning Remark" : "",
    round_1_remark: currentInterviewRoundIndex > 0 ? "Round 1 Remark" : "",
    technical_knowledge_score: currentInterviewRoundIndex > 1 ? Math.floor(Math.random() * 20) : "",
    team_player_score: currentInterviewRoundIndex > 1 ? Math.floor(Math.random() * 20) : "",
    problem_solving_skills_score: currentInterviewRoundIndex > 1 ? Math.floor(Math.random() * 20) : "",
    people_skills_score: currentInterviewRoundIndex > 1 ? Math.floor(Math.random() * 20) : "",
    round_2_score: currentInterviewRoundIndex > 1 ? Math.floor(Math.random() * 80) : "",
    technical_knowledge_remark: currentInterviewRoundIndex > 1 ? "Technical Knowledge Remark" : "",
    team_player_remark: currentInterviewRoundIndex > 1 ? "Team Player Remark" : "",
    problem_solving_skills_remark: currentInterviewRoundIndex > 1 ? "Problem Solving Skills Remark" : "",
    people_skills_remark: currentInterviewRoundIndex > 1 ? "People Skills Remark" : "",
    round_2_remark: currentInterviewRoundIndex > 1 ? "Round 2 Remark" : "",
    salary_expectation: salaryExpectation,
    salary_finalized: salaryFinalized,
    offer_letters: [offerLetters],
    salary_cap: salaryCap,
    onBoardingData:
      currentInterviewRoundIndex > 4
        ? {
            name: `Candidate ${idx + 1}`,
            email: `candidate${idx + 1}@example.com`,
            contact: `+91 ${Math.floor(Math.random() * 1000000000)}`,
            photo: "https://randomuser.me/api/portraits/men/1.jpg",
            age,
            gender,
            date_of_birth: dobString,
            residential_address: "123 Main St, City, State, ZIP",
            permanent_address: "456 Elm St, City, State, ZIP",
            nationality: "Indian",
            medical_condition: "None",
            aadhar_number: "123412341234",
            pan_number: "ABCDE1234F",
          }
        : "",

    documents:
      currentInterviewRoundIndex > 5
        ? {
            experience_letter: {
              url: "https://example.com/experience-letter.pdf",
              uploaded_date: new Date().toISOString().split("T")[0],
            },
            relieving_letter: {
              url: "https://example.com/releiving-letter.pdf",
              uploaded_date: new Date().toISOString().split("T")[0],
            },
            proof_of_age: {
              url: "https://example.com/proof-of-age.pdf",
              uploaded_date: new Date().toISOString().split("T")[0],
            },
            education_qualification_certificate: {
              url: "https://example.com/education-certificate.pdf",
              uploaded_date: new Date().toISOString().split("T")[0],
            },
            ssc: {
              url: "https://example.com/ssc-certificate.pdf",
              uploaded_date: new Date().toISOString().split("T")[0],
            },
            hsc: {
              url: "https://example.com/hsc-certificate.pdf",
              uploaded_date: new Date().toISOString().split("T")[0],
            },
            graduation_certificate: {
              url: "https://example.com/graduation-certificate.pdf",
              uploaded_date: new Date().toISOString().split("T")[0],
            },
            post_graduation_certificate: {
              url: "https://example.com/post-graduation-certificate.pdf",
              uploaded_date: new Date().toISOString().split("T")[0],
            },
            salary_slip_of_previous_employer: {
              url: "https://example.com/salary-slip.pdf",
              uploaded_date: new Date().toISOString().split("T")[0],
            },
            noc: {
              url: "https://example.com/noc.pdf",
              uploaded_date: new Date().toISOString().split("T")[0],
            },
            background_verification: true,
          }
        : "",
    contract:
      currentInterviewRoundIndex > 6
        ? {
            name: "Candidate 1_Contract",
            file_url: "https://example.com/contract.pdf",
            accepted_date: new Date().toISOString().split("T")[0],
            send_date: new Date().toISOString().split("T")[0],
          }
        : currentInterviewRoundIndex === 6
        ? [
            {
              name: "Candidate 1_Contract",
              file_url: "https://example.com/contract.pdf",
              send_date: new Date().toISOString().split("T")[0],
            },
            {
              name: "Candidate 1_Contract",
              file_url: "https://example.com/contract.pdf",
              send_date: new Date().toISOString().split("T")[0],
              rejected_date: new Date().toISOString().split("T")[0],
            },
          ][Math.floor(Math.random() * 2)]
        : null,
    date_of_joining:
      currentInterviewRoundIndex > 7
        ? new Date(
            Math.floor(Math.random() * (new Date().getTime() - new Date("2025-01-01").getTime())) + new Date().getTime()
          )
            .toISOString()
            .split("T")[0]
        : "",
    // biometrics: currentInterviewRoundIndex > 6,
    joining_kit:
      currentInterviewRoundIndex > 8
        ? {
            welcome_kit: true,
            company_policy_kit: true,
            helmet_raincoat: true,
            biometrics: true,
          }
        : "",
  };

  return {
    id: idx + 1,
    name: `Candidate ${idx + 1}`,
    email: `candidate${idx + 1}@example.com`,
    contact: `+91 ${Math.floor(Math.random() * 1000000000)}`,
    application_date: applicationDate.toISOString().split("T")[0],
    status: status,
    designation: "Designation " + ["A", "B", "C", "D"][Math.floor(Math.random() * 3)],
    next_interview_date: nextInterviewDate,
    next_interview_time: interviewTime,
    age,
    gender,
    date_of_birth: dobString,
    linkedin_url: `https://www.linkedin.com/in/candidate${idx + 1}`,
    resume_url: `https://www.example.com/resume${idx + 1}.pdf`,
    current_salary: Math.floor(Math.random() * 100000) + 100000,
    expected_salary: salaryExpectation,
    reason_for_rejection: rejectionReason,
    previous_round:
      currentInterviewRoundIndex > 0 ? allInterviewStages[currentInterviewRoundIndex - 1] : allInterviewStages[0],
    current_interview_round: currentInterviewRound,
    current_interview_round_index: currentInterviewRoundIndex,
    department: ["Drawing", "Design", "Site Visit", "Accounts", "HR"][Math.floor(Math.random() * departments.length)],
    ...scores,
  };
});

const onboardingRounds = allInterviewStages.slice(4);
const interviewRounds = allInterviewStages.slice(0, 4);
export const staticOnboardingCandidatesData = candidatesData.filter(
  (candidate) => candidate.status === "In Process" && onboardingRounds.includes(candidate.current_interview_round)
);

export const staticInterviewCandidatesData = candidatesData.filter(
  (candidate) => candidate.status === "In Process" && interviewRounds.includes(candidate.current_interview_round)
);

export const staticJobPostingsData = Array.from({ length: 10 }).map((_, idx) => {
  const minAge = Math.floor(Math.random() * 18) + 18;
  const maxAge = Math.floor(Math.random() * 18) + minAge;
  const minExperience = Math.floor(Math.random() * 10) + 1;
  const maxExperience = Math.floor(Math.random() * 10) + minExperience;
  const minCTC = Math.floor(Math.random() * 100000) + 20000;
  const maxCTC = Math.floor(Math.random() * 100000) + minCTC;
  const positionsCount = Math.floor(Math.random() * 10) + 1;

  return {
    id: idx + 1,
    posting_date: new Date(
      Math.floor(Math.random() * (new Date().getTime() - new Date("2025-01-01").getTime())) +
        new Date("2025-01-01").getTime()
    )
      .toISOString()
      .split("T")[0],
    designation: `Designation ${idx + 1}`,
    department: [...departments, "Accounts", "HR"][Math.floor(Math.random() * 5)],
    no_of_positions: positionsCount,
    applications_count: Math.floor(Math.random() * 30),
    status: ["Open", "Closed"][Math.floor(Math.random() * 2)],
    details: {
      designation: `Designation ${idx + 1}`,
      department: ["Drawing", "Design", "Accounts", "HR"][Math.floor(Math.random() * 4)],
      work_type: ["On Site", "Hybrid", "Remote"][Math.floor(Math.random() * 3)],
      job_type: ["Full-Time", "Part-Time", "Contract", "Agent", "Temporary", "Intern", "Volunteer"][
        Math.floor(Math.random() * 7)
      ],
      min_age: minAge,
      max_age: maxAge,
      gender_preferred: ["Any", "Male", "Female", "Other"][Math.floor(Math.random() * 4)],
      qualification_preferred: ["SSC", "HSC", "Diploma", "Graduation", "Post Graduation", "Ph.D"][
        Math.floor(Math.random() * 6)
      ],
      // 6-8 sentences for responsibilities
      responsibilities:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. A totam dolorum nemo possimus reprehenderit rerum sint quibusdam quas placeat vitae aliquid illum nam, eligendi esse nobis dicta, inventore nihil quae ex sed sapiente natus. Aut delectus sequi similique minima eligendi. Voluptas unde obcaecati consequuntur magni nihil veritatis sunt explicabo soluta.",
      tools_required: Array.from({ length: Math.floor(Math.random() * 5) + 2 }).map(
        (_, toolIdx) => `Tool ${toolIdx + 1}`
      ),
      min_experience: minExperience,
      max_experience: maxExperience,
      min_ctc: minCTC,
      max_ctc: maxCTC,
      no_of_positions: positionsCount,
    },
  };
});

export const staticProjectsData = Array.from({ length: 2 }).map((item, idx) => {
  return {
    id: idx + 1,
    location: `Location ${idx + 1}`,
    date_of_completion: new Date(
      Math.floor(Math.random() * (new Date().getTime() - new Date("2025-01-01").getTime())) +
        new Date("2025-01-01").getTime()
    )
      .toISOString()
      .split("T")[0],
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
    tags: ["#tag_1", "#tag_2", "#tag_3", "#tag_4", "#tag_5"],
    images: [
      "https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    ],
  };
});

export const staticNewsData = Array.from({ length: 2 }).map((item, idx) => {
  return {
    id: idx + 1,
    name: `Title ${idx + 1}`,
    headline: `Headline ${idx + 1}`,
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum",
    reference_link: "https://google.com",
    image:
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
  };
});

export const workExecutionStaticData = Array.from({ length: 20 }).map((item, idx) => {
  const drawingOptions = [
    "C1.1",
    "C1.2",
    "C2.1",
    "C2.2",
    ...Array.from({ length: 10 }).map((_, i) => `S${i + 1}.1`),
    ...Array.from({ length: 10 }).map((_, i) => `S${i + 2}.2`),
  ];
  return {
    id: idx + 1,
    drawing: drawingOptions[Math.floor(Math.random() * drawingOptions.length)],
    revision_count: `R${Math.floor(Math.random() * 3) + 1}`,
    working_hours: Math.floor(Math.random() * 2) + 2,
  };
});

export const employeeAttendanceStaticData = Array.from({ length: 28 }).map((item, idx) => {
  const actualWorkTime = 8.5;
  const workingHours = actualWorkTime + (Math.floor(Math.random() * 3) - 1);
  const overtime = workingHours > actualWorkTime ? workingHours - actualWorkTime : 0;
  const negativeHours = workingHours < actualWorkTime ? actualWorkTime - workingHours : 0;
  const calculatedSalary = workingHours * 300;
  const startTime = new Date(2025, 1, idx + 1, 9);
  const endTime = new Date(startTime.getTime() + workingHours * 60 * 60 * 1000);
  const startTimeString = startTime.toTimeString().slice(0, 5);
  const endTimeString = endTime.toTimeString().slice(0, 5);
  return {
    id: idx + 1,
    date: new Date(2025, 1, idx + 2).toISOString().split("T")[0],
    working_hours: workingHours,
    overtime,
    negative_hours: negativeHours,
    calculated_salary: calculatedSalary,
    start_time: startTimeString,
    end_time: endTimeString,
  };
});

export const staticSalaryRecords = Array.from({ length: 12 })
  .map((_, idx) => {
    // timeline is 'month, year' for the past 12 months,
    // use todays date for the current month and year
    const month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ][idx];
    const today = new Date();
    const year = today.getFullYear();
    const monthToday = today.getMonth();
    const timeline = monthToday > idx ? `${month}, ${year}` : `${month}, ${year - 1}`;

    return {
      timeline,
      total_amount: formatAmount(Math.floor(Math.random() * 1000000) + 1000000),
      payment_proof: "https://example.com/payment_proof.pdf",
      csv: "https://example.com/salaries.csv",
    };
  })
  .sort((a, b) => new Date(b.timeline).getTime() - new Date(a.timeline).getTime());

export const staticSalaryRecordsByEmployee = Array.from({ length: 20 }).map((_, idx) => {
  const prevMonth = new Date().getMonth() === 0 ? 11 : new Date().getMonth() - 1;
  const maxWorkingDays = new Date(2025, prevMonth + 1, 0).getDate();
  const workingDays = Math.floor(Math.random() * 10) + 20;
  const maxWorkingHours = 8.5 * maxWorkingDays;
  const shouldBeWorkHours = 8.5 * workingDays;
  const overtime = Math.floor(Math.random() * 3) + 1;
  const negativeHours = Math.floor(Math.random() * 3) + 1;
  const workingHours = shouldBeWorkHours + overtime - negativeHours;

  return {
    id: idx + 1,
    employee_name: `Employee ${idx + 1}`,
    employee_id: idx + 1,
    department: ["Drawing", "Design", "Site Visit", "Accounts", "HR"][Math.floor(Math.random() * 5)],
    designation: `Designation ${["A", "B", "C", "D"][Math.floor(Math.random() * 4)]}`,
    max_working_days: maxWorkingDays,
    working_days: workingDays,
    max_working_hours: maxWorkingHours,
    working_hours: workingHours,
    overtime,
    negative_hours: negativeHours * -1,
    calculated_working_hours: workingHours,
    calculated_salary: workingHours * 300,
  };
});
